<template>
  <div class="avecor-table">
    <div style="position:absolute; left:10px; top:10px;">
      <v-icon 
        class="avecor-table-actions"
        :size="16"
        style="padding-right:10px"
        @click="close()"
      >
        far fa-window-close
      </v-icon>
    </div>
    
    <div style="overflow-y:auto; max-height:400px; border-top: 2px solid #ddd;">
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="promotionContacts"
      :expanded.sync="expanded"
      :single-expand="singleExpand"
      item-key="id"
      hide-default-footer
      disable-pagination
      style="width:100%"
      class="avecor-ordered-products-table"
    >
      <template v-slot:item="{ item, expand, isExpanded }">
        <tr style="height:25px; width:100%;" class="hide-field-details">
          <td class="justify-center text-center pa-0 maxw-25" >
            <v-icon 
                size=10
                @click="isExpanded ? expand(false) : expand(true)"
                style="padding-left:3px;"
              >
                fas fa-info-circle
            </v-icon>
          </td>
          
          <td>
            {{ contacts[item].firstName + contacts[item].lastName }}
          </td>
          <td>
            {{  results[item].reduce((total,value) => {
                  if(value.action === "Sent Email") return total + 1
                  else return total
              },0) 
            }}
          </td>
          <td>
            {{  results[item].reduce((total,value) => {
                  if(value.action === "Opened Email") return total + 1
                  else return total
              },0) 
            }}
          </td>
          <td>
            {{  results[item].reduce((total,value) => {
                  if(value.action === "Clicked Email") return total + 1
                  else return total
              },0) 
            }}
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="pa-0" :colspan="headers.length">
          <v-row no-gutters >
            <v-col cols="2 pa-2 text-center" style="font-weight:bold">Päivä-Aika</v-col>
            <v-col cols="2 pa-2" style="font-weight:bold">Laitetyyppi</v-col>
            <v-col cols="2 pa-2" style="font-weight:bold">Laite</v-col>
            <v-col cols="3 pa-2" style="font-weight:bold">Aktiviteetin tyyppi</v-col>
            <v-col cols="3 pa-2" style="font-weight:bold">Aktiviteetti</v-col>
          </v-row>
          <v-row no-gutters v-for="(item) in results[item]" :key="'promtion-result-'+index">
            <v-col cols="2 pa-2 text-center">{{customFormatter(item.created_at)}}</v-col>
            <v-col cols="2 pa-2">{{item.deviceType}}</v-col>
            <v-col cols="2 pa-2">{{item.device}}</v-col>
            <v-col cols="3 pa-2">{{item.category}}</v-col>
            <v-col cols="3 pa-2">{{item.action}}</v-col>
          </v-row>
        </td>
      </template>
    </v-data-table>
    </div>
  </div>
</template>


<script>
import { mapFields,mapMultiRowFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'
var db = null

export default {
    props: ['promotionId'],
    data: () => ({
      dialog: false,
      table: null,
      autogrow: true,
      expanded: [],
      results:{},
      promotionContacts:[],
      singleExpand: true,
      selected: [],
      search: '',
      headers: [
        { text: ' ', value: 'name', align: 'center', sortable: false },
        { text: 'Kontaktin Nimi', value: 'name', align: 'left', sortable: false},
        { text: 'Lähetykset', value: 'name', align: 'left', sortable: false},
        { text: 'Avaukset', value: 'name', align: 'left', sortable: false},
        { text: 'Klikit', value: 'name', align: 'left', sortable: false},
      ],
    }),
    mounted() {
      db = firebase.firestore();
      this.getPromotionActivity()
    },
    computed: {
      ...mapFields({
        settings:"settings",
        staff:"staff.staff",
        contacts:"contact.contacts",
      }),
    },

    watch: {
      promotionId: function (val) {
        if(val === "") this.results = []
        else this.getPromotionActivity()
      },
    },
    created () {},
    methods: {
      customFormatter(date) {
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          return dateFormat(myDate, "yyyy-mm-dd HH:MM")
        }
        return ''
      },
      copyToClipboard (text) {
        this.$clipboard(text)
        this.$store.dispatch('showSnack', { snack:true, snackTimeout:1000, snackText:"Id kopioitu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
      },
      close (event) {
        this.$emit('removeSelectedPromotionIdForResults', '')
      },
      getPromotionActivity(){
        if(this.promotionId !== undefined && this.promotionId !== "") {
          var t = this
          db.collection("contactActivities").where("promotionId", "==", this.promotionId)
          .onSnapshot(function(querySnapshot) {
              t.results = {}
              t.promotionContacts = []
              var data = null
              querySnapshot.forEach(function(doc) {
                  //console.log(doc.data())
                  data = doc.data()
                  t.results[data.contactId] === undefined ? t.results[data.contactId] = [] : ""
                  t.results[data.contactId].push(data)
              });
              t.sortResultsByDate()
              t.promotionContacts = Object.keys(t.results)
          })
        }
      },
      sortResultsByDate(){
        var resultsTemp = {}
        var t = this
        Object.keys(this.results).forEach(key => {
          var sortedEvents = t.results[key].sort(function(a,b){
            var aDate = a.created_at.seconds
            var bDate = b.created_at.seconds
            return new Date(bDate) - new Date(aDate);
          });
          resultsTemp[key] = sortedEvents
        })
        this.results = resultsTemp
        
      }
    }
  }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blocks/PromotionResultsTable.vue